export default __webpack_public_path__ + "static/media/bgshape.ff7d66bc.svg";